import { helpers } from '@vuelidate/validators';

export const phoneWithCountryCode = helpers.withMessage(
  'Phone number must start with + and include country code',
  (value: string) =>
    !!value &&
    typeof value === 'string' &&
    /^\+\d{1,3}\d{7,14}$/.test(value.trim())
)
